export const SET_BALANCE_CONDITION = 'SET_BALANCE_CONDITION'
export const SET_MAP_ADDRESS_INFO = 'SET_MAP_ADDRESS_INFO' // 设置地图地址信息
export const SET_DELIVERY_VERSION = 'SET_DELIVERY_VERSION' // 设置配送是否新版本
